import {dateCompareAsc} from '@lib/utils';
import {createEntityAdapter} from '@reduxjs/toolkit';
import parseISO from 'date-fns/parseISO';
import {CalendarWeek, CalendarDay} from './types';

export const calendarWeeksAdapter = createEntityAdapter<CalendarWeek>({
  selectId: (week) => week.weekNumber,
  sortComparer: (w1, w2) => dateCompareAsc(parseISO(w1.days[0]), parseISO(w2.days[0])),
});

export const calendarDaysAdapter = createEntityAdapter<CalendarDay>({
  selectId: (day) => day.date,
  sortComparer: (d1, d2) => dateCompareAsc(parseISO(d1.date), parseISO(d2.date)),
});
